import type { StatusPresetMap } from './types'

export type TaskType = 'feature' | 'fix' | 'chore'

export const taskTypePresets: StatusPresetMap<TaskType> = {
  feature: { label: 'Feature', tone: 'success' },
  fix: { label: 'Fix', tone: 'critical' },
  chore: { label: 'Chore', tone: 'neutral' },
}
